import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CallMeBack } from '../../forms/CallMeBack';
import { Contacts } from '../../commons/Contacts';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { authSlice } from '../../../store/reducers/AuthSlice';
import { ordersApi } from '../../../services/apiServices/user/orders';
import { LoginRouteNames, ModalVariants, LocalStorageItems } from '../../../models/Common';
import { useCustomSnackbar } from '../../../hooks/useCustomEnqueueSnackbar';
import { modalSlice } from '../../../store/reducers/ModalSlice';
import { getErrorMessage } from '../../../utils';

interface PasswordRecoveryAssistance {
  handleLink: (link: LoginRouteNames) => void;
}

export const PasswordRecoveryAssistance: FC<PasswordRecoveryAssistance> = ({ handleLink }) => {
  const { t } = useTranslation();
  const { userInfoState, isUserInfoDownloaded } = useAppSelector((state) => state.userInfoReducer);
  const { isAuth } = useAppSelector((state) => state.authReducer);
  const dispatch = useAppDispatch();
  const { setFormError } = authSlice.actions;
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [callback, { isLoading }] = ordersApi.useUnauthorizedCallbackMutation();
  const { openModal } = modalSlice.actions;

  const handleSaveFormData = (phone: string) => {
    const data: Partial<{ phone: string }> = {};

    if (phone !== userInfoState.SmsSettings?.Phone) {
      data.phone = phone;
    }
    if (data.phone) {
      localStorage.setItem(
        `${LocalStorageItems.CallMeBack}-${userInfoState.id}`,
        JSON.stringify({ [userInfoState.id]: data }),
      );
    } else {
      localStorage.removeItem(`${LocalStorageItems.CallMeBack}-${userInfoState.id}`);
    }
  };

  const handleCallMeBack = async (callMe: { phone: string; viber: boolean; userComment: string }) => {
    dispatch(setFormError(null));
    const comment = `Сайт: ${process.env.REACT_APP_NAME || ''}. Забыл пароль, нужна помощь. Телефон: ${callMe.phone}. ${
      callMe.viber ? ` Дополнительная связь: Viber.` : ''
    }${callMe.userComment.trim() ? ` Комментарий: ${callMe.userComment.trim()}` : ''}`;

    try {
      await callback({ phone: callMe.phone, comment })
        .unwrap()
        .then(() => {
          dispatch(
            openModal({
              modalVariants: ModalVariants.Success,
              content: {
                title: `${t('modals.thankYou')}`,
                description: `${t('modals.requestAcceptedAnOperatorWillContactYouShortly')}`,
              },
            }),
          );
          if (isAuth) handleSaveFormData(callMe.phone);
          handleLink(LoginRouteNames.AuthForm);
        });
    } catch (err: unknown) {
      const message = getErrorMessage(err);
      customEnqueueSnackbar(message, 'error');
    }
  };

  return (
    <div className="password-recovery-assistance">
      <p className="password-recovery-assistance__title login-page__title">{t('auth.passwordRecoveryAssistance')}</p>
      <div className="password-recovery-assistance__form-container">
        {!isAuth ? (
          <CallMeBack handleCallMeBack={handleCallMeBack} isLoading={isLoading} />
        ) : (
          isUserInfoDownloaded && <CallMeBack handleCallMeBack={handleCallMeBack} isLoading={isLoading} />
        )}
      </div>
      <Contacts isColored />
    </div>
  );
};
